import { portalPaths, UrlParams } from '@provision/portal-routes';
import { RULES_MAP_PER_VIEW_ENTITY } from 'src/graphql/entities/custom-view';
import { optionalRouteParam } from 'src/utils/routing';
import { NavigationDataItem } from './use-navigation-items';

export enum NavbarItemId {
  Views = 'views',
  Conversations = 'conversations',
  Sites = 'sites',
  Clients = 'clients',
  Projects = 'projects',
  MyDrafts = 'my-drafts',
}

export const PLATFORM_PARTNER_HIDDEN_MENU_ITEMS: string[] = [
  NavbarItemId.Conversations,
  NavbarItemId.Sites,
  NavbarItemId.Clients,
];

export const BASE_WORKSPACE_MENU_ITEMS: NavigationDataItem[] = [
  {
    id: NavbarItemId.Views,
    title: 'Views',
    iconData: { name: 'eye', library: 'lucide' },
    // used to navigation into
    path: portalPaths.customView.view('conversations'),
    // used to identify whenever nav item is active or not
    pathTemplate: portalPaths.customView.view(optionalRouteParam(UrlParams.entityName)),
    ...RULES_MAP_PER_VIEW_ENTITY.conversation,
    isMultitenancyAllowed: true,
  },
  {
    id: NavbarItemId.Conversations,
    title: 'Conversations',
    iconData: { name: 'messages-square', library: 'lucide' },
    path: portalPaths.entity.all({
      entityName: 'conversations',
    }),
    pathTemplate: portalPaths.entity.all({
      entityName: optionalRouteParam('conversations'),
      id: optionalRouteParam(UrlParams.recordId),
    }),
    ...RULES_MAP_PER_VIEW_ENTITY.conversation,
    isMultitenancyAllowed: true,
  },
  {
    id: NavbarItemId.MyDrafts,
    title: 'My Drafts',
    iconData: { name: 'file-pen', library: 'lucide' },
    path: portalPaths.drafts.root(),
    ...RULES_MAP_PER_VIEW_ENTITY.conversation,
    isMultitenancyAllowed: true,
    badgeDataPath: 'draftsCount',
    hideWithNoCount: true,
  },
];

export const CRM_REPLACEMENT_MENU_ITEMS: NavigationDataItem[] = [
  {
    id: NavbarItemId.Sites,
    title: 'Sites',
    iconData: { name: 'building-2', library: 'lucide' },
    path: portalPaths.entity.all({
      entityName: 'sites',
    }),
    pathTemplate: portalPaths.entity.all({
      entityName: optionalRouteParam('sites'),
      id: optionalRouteParam(UrlParams.recordId),
    }),
    isMultitenancyAllowed: true,
    isMobileSupported: true,
  },
  {
    id: NavbarItemId.Clients,
    title: 'Clients',
    iconData: { name: 'user', library: 'lucide' },
    path: portalPaths.entity.all({
      entityName: 'clients',
    }),
    pathTemplate: portalPaths.entity.all({
      entityName: optionalRouteParam('clients'),
      id: optionalRouteParam(UrlParams.recordId),
    }),
    isMultitenancyAllowed: true,
    isMobileSupported: true,
  },
  {
    id: NavbarItemId.Projects,
    title: 'Projects',
    iconData: { name: 'folder-open', library: 'lucide' },
    path: portalPaths.entity.all({
      entityName: 'projects',
    }),
    pathTemplate: portalPaths.entity.all({
      entityName: 'projects',
      id: optionalRouteParam(UrlParams.recordId),
    }),
    ...RULES_MAP_PER_VIEW_ENTITY.project,
    isMultitenancyAllowed: false,
    isMobileSupported: true,
  },
];
